import { env } from 'src/env';

export function requestNewPassword(email: string) {
  const formData = new FormData();
  formData.append('email', email);
  return fetch(`${env.OLD_API_HOST}/users/reset`, {
    credentials: 'include',
    method: 'POST',
    body: formData,
  }).then(async (response) => {
    if (!response.ok) {
      throw Error(await response.text());
    }

    return response.text();
  });
}
